import { type Report } from '@littlebird/sdk';
import { observer } from 'mobx-react-lite';

import { YStack } from '@/components/ui/layout/layout';
import { ArtifactCard, ArtifactCardSkeleton } from '@/features/artifacts';
import { useOpenRoutineArtifact } from '@/features/routines/hooks/use-open-routine-artifact';
import { useHydratedFiles } from '@/hooks/useHydratedFile';

const MAX_SHOWN = 3;

export const HomeRoutineArtifacts = observer(
  ({ report }: { readonly report: Report }) => {
    const shownIds = report.artifactFileIds.slice(0, MAX_SHOWN);
    const artifacts = useHydratedFiles(shownIds);
    const openArtifact = useOpenRoutineArtifact(report);
    if (artifacts.every(({ status }) => status === 'unavailable')) return null;

    return (
      <YStack className="gap-2 pt-[calc(16*var(--ac-u))]">
        {artifacts.map((artifact, index) =>
          artifact.status === 'ready' ? (
            <ArtifactCard
              key={shownIds[index]}
              file={artifact.file}
              onOpen={openArtifact}
            />
          ) : artifact.status === 'loading' ? (
            <ArtifactCardSkeleton key={shownIds[index]} />
          ) : null
        )}
      </YStack>
    );
  }
);
